/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateConfigurationRequestBody,
  UpdateConfigurationRequestBody$Outbound,
  UpdateConfigurationRequestBody$outboundSchema,
} from "../components/updateconfigurationrequestbody.js";

export type UpdateDeviceAgentConfigurationSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateDeviceAgentConfigurationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateConfigurationRequestBody: UpdateConfigurationRequestBody;
};

/** @internal */
export type UpdateDeviceAgentConfigurationSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateDeviceAgentConfigurationSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateDeviceAgentConfigurationSecurity$Outbound,
    UpdateDeviceAgentConfigurationSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateDeviceAgentConfigurationSecurityToJSON(
  updateDeviceAgentConfigurationSecurity:
    UpdateDeviceAgentConfigurationSecurity,
): string {
  return JSON.stringify(
    UpdateDeviceAgentConfigurationSecurity$outboundSchema.parse(
      updateDeviceAgentConfigurationSecurity,
    ),
  );
}

/** @internal */
export type UpdateDeviceAgentConfigurationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateConfigurationRequestBody: UpdateConfigurationRequestBody$Outbound;
};

/** @internal */
export const UpdateDeviceAgentConfigurationRequest$outboundSchema:
  z.ZodMiniType<
    UpdateDeviceAgentConfigurationRequest$Outbound,
    UpdateDeviceAgentConfigurationRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      updateConfigurationRequestBody:
        UpdateConfigurationRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        updateConfigurationRequestBody: "UpdateConfigurationRequestBody",
      });
    }),
  );

export function updateDeviceAgentConfigurationRequestToJSON(
  updateDeviceAgentConfigurationRequest: UpdateDeviceAgentConfigurationRequest,
): string {
  return JSON.stringify(
    UpdateDeviceAgentConfigurationRequest$outboundSchema.parse(
      updateDeviceAgentConfigurationRequest,
    ),
  );
}
